
export class AddressModel {
  adr_key: string = null;
  adr_line1: string = null;
  adr_line2: string = null;
  adr_city: string = null;
  adr_county: string = null;
  adr_state: string = null;
  adr_post_code: string = null;
  adr_intl_province: string = null;
  adr_latitude: number = null;
  adr_longitude: number = null;
  adr_cong_dist: string = null;
  adr_carrier_route: string = null;
  adr_fips: string = null;
  adr_time_zone: string = null;
  adr_delivery_point_code: string = null;
  adr_mailing_label: string = null;
  adr_country: string = null;

  constructor(source?: any) {
    this.adr_country = 'UNITED STATES';

    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
}
